import React from 'react'
import {Box} from '@chakra-ui/react'
import { motion } from 'framer-motion'

const RotateAnimation = ({children,delayTime}) => {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, rotate: 360 }}
            transition={{
                duration: 0.75,
                delay: delayTime,
                ease: "easeIn"
            }}
        >
            <Box mr="1rem" color="primary.light" fontSize="3.5rem">{children}</Box>
        </motion.div>
    )
}

export default RotateAnimation
